"use strict";
// Copyright (c) 2020 WiseTime. All rights reserved.
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.from = void 0;
var Grpc = __importStar(require("grpc-web"));
var rxjs_1 = require("rxjs");
var isServerStreaming = function (response) {
    return "on" in response;
};
var fromServerStreaming = function (call, observer) {
    call.on("data", function (data) {
        return data !== undefined
            ? observer.next(data)
            : observer.error(new Error("Response payload is undefined"));
    });
    call.on("error", function (error) { return observer.error(error); });
    call.on("status", function (status) {
        if (status.code == Grpc.StatusCode.OK) {
            observer.complete();
        }
    });
};
var fromUnary = function (call, observer) {
    return call
        .then(function (value) {
        observer.next(value);
        observer.complete();
    })
        .catch(function (err) { return observer.error(err); });
};
/**
 * Create an {@link Observable} from a gRPC call.
 *
 * Currently only supports unary and server streaming RPCs because {@link gRPC-web|https://github.com/grpc/grpc-web}
 * only supports those for now.
 *
 * @param rpc - gRPC-web call which can either be unary or server-streaming
 */
var from = function (rpc) {
    return new rxjs_1.Observable(function (observer) {
        var call = rpc();
        if (isServerStreaming(call)) {
            fromServerStreaming(call, observer);
        }
        else {
            fromUnary(call, observer);
        }
    });
};
exports.from = from;
